// =====================================================================
// SYSTEM ADMIN ALLOWLIST — DRIFT WARNING
// =====================================================================
// This allowlist is hardcoded in THREE places that MUST stay in sync:
//   1. Gateway env  : SYSTEM_ADMIN_CLERK_USER_IDS  (source of truth)
//   2. MRP backend  : _SYSTEM_ADMIN_ALLOWLIST in routes/admin_handoff.py
//   3. MRP frontend : ADMIN_ALLOWLIST here in this file
// If you add or remove a system admin, update ALL THREE. Gateway is
// enforced authoritatively; this copy only governs whether the
// "System Admin" sidebar entry RENDERS. A non-allowlisted user who
// calls /api/admin/handoff directly via devtools gets a 403 from
// MRP backend AND a 403 from the Gateway. See
// /app/memory/MRP_CONNECTION_STATUS.md.
// =====================================================================

export const ADMIN_ALLOWLIST = new Set([
  // BevNET org (org_3GuX44AHsrToP10cCRLLS9K5zXN) admins — the two system
  // admins. Clerk user IDs are per-instance, so both the production and
  // development IDs are listed for each person.
  // production  instance ins_3EwtDq40TU3SixJ9db7j4nLNyrv (clerk.nombaseconnect.com)
  'user_3GuU3JNzNdZwQAPep13TQQwutxK', // rking@bevnet.com (Ryan King)
  'user_3GsHOFF0RWly2wtFniEdb7VRweE', // jcraven@bevnet.com (John Craven)
  // development instance ins_3DM7phmGHUa9M9bJ1OsdaMCEvYK (clever-seasnail-83)
  'user_3EHxFMA25HS5Q9mwwTxzx4U30Ep', // rking@bevnet.com (Ryan King)
  'user_3EPRmM9NHkelGxJbSKcNDchFwKF', // jcraven@bevnet.com (John Craven)
]);

export const isAdminAllowed = (clerkUserId) =>
  typeof clerkUserId === 'string' && ADMIN_ALLOWLIST.has(clerkUserId);
